import {AgoraCredentialsInterface} from "@api/models/interfaces/web-conference/AgoraCredentialsInterface";
import {AgoraRoleTypes} from "@share/web-conferences/enums/AgoraRoleTypes";

export class AgoraCredentials implements AgoraCredentialsInterface {
    appId: string;
    channelId: string;
    token: string;
    userId: string | number;
    screenSharingUserId?: string;
    screenSharingToken?: string;
    rtmToken: string;

    constructor(data: AgoraCredentialsInterface) {
        Object.assign(this, data);
    }
}
